import React, { useEffect } from 'react';
import { Provider } from 'urql';
import { AppContextProvider } from './context/AppContext';
import { BpAuthProvider } from './BpAuthProvider';
import { ErrorBoundary } from './ErrorBoundary';
import { urqlClient } from './utils/urqlClient';
import { RequireMatrix } from './RequireMatrix';
import { RequireAuth } from './RequireAuth';
import { RequireBackend } from 'RequireBackend';
import { DataLoader } from 'DataLoader';
import { IsDesktopContextProvider } from 'context/IsDesktop';

export function App() {
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    const _mtm = (window._mtm = window._mtm || []);
    _mtm.push({ 'mtm.startTime': new Date().getTime(), event: 'mtm.Start' });
    (function () {
      const d = document,
        g = d.createElement('script'),
        s = d.getElementsByTagName('script')[0];
      g.async = true;
      g.src = 'https://matomo.tks.eu/js/container_fiWk8aXC_dev_0adbd5f799f9ebfc57fb7395.js';
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      s.parentNode.insertBefore(g, s);
    })();
  }, []);

  return (
    <ErrorBoundary>
      <BpAuthProvider>
        <RequireAuth>
          <RequireMatrix>
            <RequireBackend>
            <AppContextProvider>
              <Provider value={urqlClient}>
                <IsDesktopContextProvider>
                  <DataLoader />
                </IsDesktopContextProvider>
              </Provider>
            </AppContextProvider>
            </RequireBackend>
          </RequireMatrix>
        </RequireAuth>
      </BpAuthProvider>
    </ErrorBoundary>
  );
}
